
import { defineComponent, ref, reactive } from 'vue';
import { Form } from '@/components/ui-elements';
import Button from '@/components/ui-elements/form/Button.vue';
import Input from '@/components/ui-elements/form/Input.vue';

export default defineComponent({
	components: {
		Button,
		Form,
		Input,
	},
	setup() {
		const valid = ref(false);
		const form = reactive({
			password: {
				rules: ['required', 'min:8', 'alpha-numeric', 'upper'],
				value: '',
			},
			confirm_password: {
				rules: ['required', 'match:new-password'],
				value: '',
			},
		});

		return { form, valid };
	},
});
